import { useState } from 'react';
import { MarkerProviderProps } from '../../types/OfflineLocation';

const MarkerProvider = ({ MarkerContext, children }: MarkerProviderProps) => {
  const [clickedMarkerId, setClickedMarkerId] = useState<string | null>(null);
  const handleMarkerClick = (id: string) => {
    setClickedMarkerId(id);
  };

  return (
    <MarkerContext.Provider value={{ clickedMarkerId, handleMarkerClick }}>
      {children}
    </MarkerContext.Provider>
  );
};

export default MarkerProvider;
